import request from '@/utils/request'
const BASE_URL = '/RpReceiptDoc'

//收款单
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  updateSaDoc(id) {
    return request({
      url: BASE_URL + '/UpdateSaDoc',
      method: 'get',
      params:{id}
    })
  },
  updateSaDocList(data) {
    return request({
      url: BASE_URL + '/UpdateSaDocList',
      method: 'post',
      data
    })
  },
  getSaDocIds(data) {
    return request({
      url: BASE_URL + '/GetSaDocIds',
      method: 'post',
      data
    })
  },
  review(id) {
    return request({
      url: BASE_URL + '/Review',
      method: 'get',
      params: { id }
    })
  },
  back(id) {
    return request({
      url: BASE_URL + '/Back',
      method: 'get',
      params: { id }
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  clear(id) {
    return request({
      url: BASE_URL + '/Clear',
      method: 'get',
      params: { id }
    })
  },
  //获取列表 已收款（0.应收款/1.预收款/2.直接收款）
  alreadyList(data) {
    return request({
      url: BASE_URL + '/VRpAlreadyRcvDocList',
      method: 'post',
      data
    })
  },
  //获取列表 已收款（预收款）
  alreadyList0(data) {
    return request({
      url: BASE_URL + '/VRpAlreadyRcvDocList_0',
      method: 'post',
      data
    })
  },
  //获取列表 已收款（应收款）
  alreadyList1(data) {
    return request({
      url: BASE_URL + '/VRpAlreadyRcvDocList_1',
      method: 'post',
      data
    })
  },
  //获取列表 已收款（直接收款）
  alreadyList2(data) {
    return request({
      url: BASE_URL + '/VRpAlreadyRcvDocList_2',
      method: 'post',
      data
    })
  },
  //获取列表 应收对账/客户对账
  getListChkRcv(data) {
    return request({
      url: BASE_URL + '/GetListChkRcv',
      method: 'post',
      data
    })
  },
  //获取列表 应收明细账
  getListDetailRcv(data) {
    return request({
      url: BASE_URL + '/GetListDetailRcv',
      method: 'post',
      data
    })
  },
  //获取列表 应收总账 (Kind = 《空字符串''》/普通应收/预收/其它应收)
  getRpRcvPaySum(data) {
    return request({
      url: BASE_URL + '/GetRpRcvPaySum',
      method: 'post',
      data
    })
  },
}